import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../src/components/Table/Table';

const WorkoutList = ({ workouts }) => {
  if (workouts.length === 0) {
    return <p>No workouts found.</p>;
  }

  const columns = [
    { title: 'Name', field: 'name' },
    { title: 'Description', field: 'description' },
    { title: 'Equipment Needed', field: 'equipmentNeeded', render: (rowData) => (rowData.equipmentNeeded ? 'Yes' : 'No') },
    { title: 'Category', field: 'categoryName' },
  ];

  return (
    <Table
      title="Workouts"
      columns={columns}
      data={workouts}
      options={{
        paging: true,
        search: true,
        sorting: true,
        filtering: false,
      }}
    />
  );
};

WorkoutList.propTypes = {
  workouts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      description: PropTypes.string,
      equipmentNeeded: PropTypes.bool.isRequired,
      categoryName: PropTypes.string,
    })
  ).isRequired,
};

export default WorkoutList;
